/*
 * クライアント ファイル共有の作成
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_CLIENT_RFP_SHARE_DOCUMENT_ALL = 'API_CREATE_CLIENT_RFP_SHARE_DOCUMENT_ALL';
export const API_CREATE_CLIENT_RFP_SHARE_DOCUMENT_MESSAGE_LOG = 'API_CREATE_CLIENT_RFP_SHARE_DOCUMENT_MESSAGE_LOG';
/** クライアント ファイル共有：一括送付 */
export const apiCreateClientRfpShareDocumentAll = ({ json, path: { id } }, meta) => apiCreate(API_CREATE_CLIENT_RFP_SHARE_DOCUMENT_ALL, `/client/rfp/${id}/share_document_all`, json, meta);
/** クライアント ファイル共有：既読ログ作成 */
export const apiCreateClientRfpShareDocumentMessageLog = ({ path: { id, share_document_message_id: shareDocumentMessageId, view_request_id: viewRequestId, }, }, meta) => apiCreate(API_CREATE_CLIENT_RFP_SHARE_DOCUMENT_MESSAGE_LOG, `/client/rfp/${id}/share_document_message_log/${viewRequestId}/message/${shareDocumentMessageId || ''}`, {}, meta);
